import SidePanel from '../SidePanel';
import Header from '../Header';
import { MainWrapper } from '../../../styles/chime-react/CommonStyles';
import BackToTop from '../BackToTop';
import { useState, useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { useInternalSession } from '../../../providers/SessionProvider';

const Layout = ({ page }) => {
  const [showSidePanelMenu, setShowSidePanelMenu] = useState(false);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { status } = useInternalSession();
  const isAuthenticated = status === 'authenticated';

  useEffect(() => {
    // ページ変更時にサイドメニューを非表示にする
    setShowSidePanelMenu(false);
  }, [pathname, searchParams]);

  return (
    <>
      <Header
        isLoggedIn={isAuthenticated}
        hasSidePanelMenu
        isHamburgerOpen={showSidePanelMenu}
        onClickHamburger={() => setShowSidePanelMenu(!showSidePanelMenu)}
      ></Header>
      <MainWrapper hasSidePanel={true} isLoggedIn={isAuthenticated}>
        <SidePanel
          page={page}
          showSidePanelMenu={showSidePanelMenu}
          onClickOverlay={() => setShowSidePanelMenu(false)}
        />
        <BackToTop />
      </MainWrapper>
    </>
  );
};

export default Layout;
